'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _options = require('../common/options');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiniLineComponent = function (_BaseComponent) {
    (0, _inherits3.default)(MiniLineComponent, _BaseComponent);

    function MiniLineComponent(props) {
        (0, _classCallCheck3.default)(this, MiniLineComponent);
        return (0, _possibleConstructorReturn3.default)(this, (MiniLineComponent.__proto__ || (0, _getPrototypeOf2.default)(MiniLineComponent)).call(this, props));
    }

    /**
     * 矫正 option
     */


    (0, _createClass3.default)(MiniLineComponent, [{
        key: 'packageOption',
        value: function packageOption() {
            var option = JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _options.MiniLineOption)));
            var _props = this.props,
                type = _props.type,
                color = _props.color,
                lineWidth = _props.lineWidth,
                hasTooltip = _props.hasTooltip,
                animation = _props.animation,
                symbol = _props.symbol,
                symbolSize = _props.symbolSize,
                data = _props.data;

            var xData = [];
            var yData = [];
            option.tooltip.show = hasTooltip;
            if (color && color.length) {
                option.color = color;
            }
            option.animation = animation;
            if (data && data.length) {
                data.forEach(function (obj) {
                    xData.push(obj.x);
                    yData.push(obj.y);
                });
                option.xAxis.data = xData;
                option.series = {
                    type: 'line',
                    data: yData,
                    smooth: true,
                    symbol: symbol,
                    symbolSize: symbolSize,
                    lineStyle: {
                        normal: {
                            width: lineWidth
                        }
                    }
                };
                if (type === 'area') {
                    option.series.areaStyle = { normal: {} };
                }
            }

            return option;
        }
    }]);
    return MiniLineComponent;
}(_Base2.default);

exports.default = MiniLineComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/MiniLine.js
// module id = 609
// module chunks = 0